import React, { useEffect, useRef, useState } from 'react';

import { useReactToPrint } from 'react-to-print';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

function SoftBill(props) {





    return (
        <>

        </>
    );
}

export default SoftBill;